module.exports = __webpack_public_path__ + "img/biaoti_2.d42a1558.png";